import { Col, Stack, Container } from "react-bootstrap";
import { useMemo, useState } from "react";
import LoadingIndicator from "../LoadingIndicator";
import ErrorResponse from "../ErrorResponse";
import ExportData from "../ExportData";
import useSortableData from "../useSortableData";
import moment from "moment/min/moment-with-locales";
import SongSearchInput from "../SearchInput";
import { useResolvedRadioNames } from "../HelperHooks";
import EmptyRow from "../EmptyRow";
import SongsHeader from "./SongsHeader";
import SongRow from "./SongRow";
import SongCatalogueModal from "../songCatalogue/SongCatalogueModal";

export default function NewMusicTable({ data, loading, error }) {
    const [catalogueSong, setCatalogueSong] = useState(null);
    const [filterData, setFilterData] = useState({ searchString: "" });

    const resolvedRadios = useResolvedRadioNames();

    const songsMemo = useMemo(() => {
        if (data) {
            let filteredData = data.songs;
            if (filterData.searchString) {
                filteredData = filteredData.filter(
                    x =>
                        x.artist.toLowerCase().includes(filterData.searchString.toLowerCase().trim()) ||
                        x.title.toLowerCase().includes(filterData.searchString.toLowerCase().trim()) ||
                        x.release_year?.toString().includes(filterData.searchString.trim()) ||
                        moment(x.first_play).format("L")?.toString().toLowerCase().includes(filterData.searchString.trim())
                );
            }
            return filteredData;
        }
    }, [data, filterData.searchString]);

    const { sortedItems, requestSort, sortConfig } = useSortableData(songsMemo, { key: "spins", direction: "descending" });

    const csvHeaders = ["Artist", "Title", "Release Year", "Spins", "First played", "First on"];
    const csvData = useMemo(() => {
        if (!sortedItems || !resolvedRadios) return [];
        return sortedItems.map(x => [
            x.artist,
            x.title,
            x.release_year,
            x.spins,
            moment(x.first_play).format("L HH:mm"),
            resolvedRadios.find(r => r.radio_id === x.first_on)?.radio_name ?? "Unknown",
        ]);
    }, [resolvedRadios, sortedItems]);

    return (
        <>
            {loading ? (
                <LoadingIndicator width={75} />
            ) : error ? (
                <ErrorResponse errorCode={error} />
            ) : (
                data && (
                    <>
                        <Stack direction="horizontal" gap={2} className=" mb-2 flex-wrap-reverse">
                            <Col xs xl={5}>
                                <SongSearchInput filterData={filterData} setFilterData={setFilterData} />
                            </Col>
                            <Col xs={"auto"} className="ms-auto">
                                <Stack direction="horizontal" gap={1} className="ms-xl-auto w-100 w-xl-auto order-first order-xl-last">
                                    <span className="me-1 d-none d-md-inline-block">Download:</span>
                                    <ExportData data={csvData} headers={csvHeaders} filename={"New Songs in Market"} />
                                </Stack>
                            </Col>
                        </Stack>
                        <SongsHeader sortConfig={sortConfig} requestSort={requestSort} showFirstOn showFirstPlay showSpins showReleaseYear />
                        <Container fluid>
                            {sortedItems?.length ? (
                                sortedItems.map(x => (
                                    <SongRow key={x.item_id} item={x} setCatalogueSong={setCatalogueSong} showFirstOn showFirstPlay showSpins showReleaseYear />
                                ))
                            ) : (
                                <EmptyRow text="No Songs" />
                            )}
                        </Container>
                    </>
                )
            )}
            <SongCatalogueModal show={!!catalogueSong} onHide={() => setCatalogueSong(null)} song={catalogueSong} />
        </>
    );
}
